import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Avatar from '../../Clients/Avatar';
import Name from '../../Clients/Name';

// TODO: вынести типизацию менеджера при рефакторинге ЦРМ
interface IManager {
  avatarUrl: string | null;
  email: string;
  id: string;
  name: string;
  phone: string | null;
  title: string;
  value: string;
}

interface TicketViewingManagersListProps {
  className?: string;
  managers: IManager[];
  viewingManagersIds: string[];
}

const TicketViewingManagersList = ({
  className,
  managers,
  viewingManagersIds,
}: TicketViewingManagersListProps) => {
  const [viewingManagers, setViewingManagers] = useState<IManager[]>([]);

  useEffect(() => {
    const filteredManagers = managers.filter((manager: IManager) =>
      viewingManagersIds.includes(manager.id)
    );
    setViewingManagers(filteredManagers);
  }, [viewingManagersIds]);

  if (!viewingManagersIds || !viewingManagersIds.length) {
    return null;
  }

  return (
    <StyledTicketViewingManagersListWrapper className={className}>
      <StyledTitle>Просматривают в данный момент:</StyledTitle>
      <StyledViewingManagersWrapper>
        {viewingManagers.map(manager => (
          <StyledViewingManager>
            <StyledAvatar name={manager.name} url={manager.avatarUrl} />
            <StyledName name={manager.name} />
          </StyledViewingManager>
        ))}
      </StyledViewingManagersWrapper>
    </StyledTicketViewingManagersListWrapper>
  );
};

const StyledTicketViewingManagersListWrapper = styled.div`
  padding: 5px 0;
`;

const StyledTitle = styled.div`
  font-size: 12px;
  color: rgb(145, 148, 153);
  margin-bottom: 8px;
`;

const StyledName = styled(Name)`
  font-size: 14px;
  font-weight: 300;
`;

const StyledViewingManagersWrapper = styled.ul`
  list-style: none;
  margin-left: 6px;
`;

const StyledAvatar = styled(Avatar)``;

const StyledViewingManager = styled.li`
  align-items: center;
  display: flex;

  &:not(:last-of-type) {
    margin-bottom: 5px;
  }

  ${StyledAvatar} {
    height: 18px;
    width: 18px;
  }

  ${StyledName} {
    margin-left: 6px;
  }
`;

export default TicketViewingManagersList;
